import React from "react";

// Reusable Confirm Delete PopUp Component
const DeletePopUp = ({ isPopUp, setIsPopup, onConfirm }) => {
  return (
    isPopUp && (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
          <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
            Are you sure?
          </h2>
          <p className="text-gray-600 mb-6 text-center">
            Are you sure you want to delete this document?
          </p>
          <div className="flex justify-center space-x-4">
            <button
              className="px-4 py-2 bg-gray-300 text-gray-800 font-medium rounded-md hover:bg-gray-400 transition"
              onClick={() => setIsPopup(false)}
            >
              No
            </button>
            <button
              onClick={() => {
                onConfirm();
                setIsPopup(false);
              }}
              className="px-4 py-2 bg-[#21283e] text-white font-medium rounded-md hover:bg-black transition"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default DeletePopUp;
